//
// Copyright 2026 DXOS.org
//

import * as Skill from '@dxos/compute/Skill';

import { DelegateTask } from './operations/definitions';

const SKILL_KEY = 'org.dxos.skill.delegation';

const make = () =>
  Skill.make({
    key: SKILL_KEY,
    name: 'Delegation',
    description: 'Delegates work to sub-agents and tracks it as plan tasks.',
    tools: Skill.toolDefinitions({ operations: [DelegateTask] }),
  });

const skill: Skill.Definition = {
  key: SKILL_KEY,
  make,
};

export default skill;
